import { getInvitesByUser } from '@/features/authentication/api/inviteApi';
import type { InviteResponse } from '@/features/authentication/types/invite';

export type PendingInvitation = {
  id: string;
  clientEmail: string;
  clientName: string | null;
  status: 'PENDING' | 'ACCEPTED';
  createdAt: string;
  /** Whether 30-minute cooldown has passed and resend is available */
  canResend: boolean;
  /** When resend will be available (ISO timestamp) */
  resendAvailableAt: string | null;
};

/**
 * Map InviteResponse from new invites API to PendingInvitation format
 */
function mapInviteToInvitation(invite: InviteResponse): PendingInvitation {
  return {
    id: invite.id,
    clientEmail: invite.email,
    clientName: `${invite.firstName} ${invite.lastName}`.trim() || null,
    status: invite.accepted ? 'ACCEPTED' : 'PENDING',
    createdAt: invite.createdAt,
    canResend: invite.canResend,
    resendAvailableAt: invite.resendAvailableAt,
  };
}

/**
 * Fetch list of pending invitations for the current Professional
 * Uses the new /invites/by-user endpoint which reads from the Invite table
 * 
 * @returns Array of pending invitations
 * @throws Error if request fails
 */
export async function fetchPendingInvitations(): Promise<PendingInvitation[]> {
  const response = await getInvitesByUser({ status: 'pending' });
  return response.data.map(mapInviteToInvitation);
}

